import React from 'react';
import { IoReceiptOutline } from "react-icons/io5";
import { LuLayoutDashboard } from "react-icons/lu";
import { IoCalendarOutline } from "react-icons/io5";
import { MdPeopleOutline } from "react-icons/md";
import { IoLogOutOutline } from "react-icons/io5";
import { FaRegCalendarCheck } from "react-icons/fa";
import { AiOutlineSetting } from "react-icons/ai";
import { HiOutlinePresentationChartLine } from "react-icons/hi2";





import './Sidebar.css';
import { visibleMenuLabels, pathForMenuLabel, isAdminUser } from '../../lib/permissions';

const ALL_MENU_ITEMS = [
    { icon: <LuLayoutDashboard />, label: 'Dashboard' },
    { icon: <FaRegCalendarCheck />, label: 'Appointments' },
    { icon: <IoReceiptOutline />, label: 'Billing' },
    { icon: <MdPeopleOutline />, label: 'PatientRecords' },
    { icon: <IoCalendarOutline />, label: 'Schedule' },
    { icon: <HiOutlinePresentationChartLine />, label: 'RevenueReports' },
    { icon: <AiOutlineSetting />, label: 'Settings' },
];

const Sidebar = ({ user, onMenuClick, activeMenu, onLogout }) => {
    const allowed = new Set(visibleMenuLabels(user));
    const menuItems = ALL_MENU_ITEMS.filter((item) => allowed.has(item.label));

    const handleMenuClick = (label) => {
        onMenuClick(label);
        window.history.pushState({}, '', `/${pathForMenuLabel(label)}`);
    };

    const handleLogoClick = () => {
        onMenuClick("Dashboard");
        window.history.pushState({}, "", "/dashboard");
        window.dispatchEvent(new PopStateEvent("popstate"));
    };



    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <div className="admin-panel-badge sidebar-logo-clickable" onClick={handleLogoClick} role="button" tabIndex={0}
                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleLogoClick(); }}>
                    <img src="/clinic-logo.png" alt="Clinic logo" className="sidebar-clinic-logo" />
                </div>
                <div className="admin-label">
                    {isAdminUser(user) ? 'Admin' : 'Front Desk'}
                </div>
            </div>

            <nav className="sidebar-nav">
                {menuItems.map((item, index) => (
                    <div
                        key={index}
                        className={`menu-item ${activeMenu === item.label ? 'active' : ''}`}
                        onClick={() => handleMenuClick(item.label)}                >
                        <span className="menu-icon">{item.icon}</span>
                        <span className="menu-label">{item.label}</span>
                        {item.count && <span className="menu-badge">{item.count}</span>}


                    </div>
                ))}
            </nav>

            <div className="sidebar-footer">
              

                <div className="logout-item" onClick={onLogout}>
                    <IoLogOutOutline className="logout-icon" />
                    <span>Logout</span>
                </div>
            </div>

        </div>
    );
};

export default Sidebar;
